import type { GetCourses200CoursesItem } from './getCourses200CoursesItem';
import type { GetCourses200Pagination } from './getCourses200Pagination';

export type GetCourses200 = {
  /** 조회된 강의 목록 */
  courses: GetCourses200CoursesItem[];
  /** 페이지네이션 정보 (Spring Data Page 스타일) */
  pagination: GetCourses200Pagination;
};
